import { Injectable } from '@angular/core'
import {
  Converter,
  ConverterService,
  Facet,
  Occ,
  PRODUCT_NORMALIZER,
  ProductSearchPage
} from '@spartacus/core'

@Injectable({ providedIn: 'root' })
export class EbProductSearchPageNormalizer implements Converter<
  Occ.ProductSearchPage,
  ProductSearchPage
> {
  constructor(private readonly converterService: ConverterService) {}

  /**
   * Specifies the minimal number of top values in case
   * non have been setup by the business.
   */
  protected DEFAULT_TOP_VALUES = 6

  convert(source: Occ.ProductSearchPage, target: ProductSearchPage = {}): ProductSearchPage {
    target = {
      ...target,
      ...(source as any)
    }

    this.normalizeFacets(target)
    if (source.products) {
      target.products = source.products.map(product =>
        this.converterService.convert(product, PRODUCT_NORMALIZER)
      )
    }
    return target
  }

  private normalizeFacets(target: ProductSearchPage): void {
    this.normalizeFacetValues(target)
  }

  /*
   * In case there are so-called `topValues` given for the facet values,
   * values are obsolete.
   *
   * `topValues` is a feature in Adaptive Search which can limit a large
   * amount of facet values to a small set (5 by default). As long as the backend
   * provides all facet values AND topValues, we normalize the data to not bother
   * the UI with this specific feature.
   */
  private normalizeFacetValues(target: ProductSearchPage): void {
    if (target.facets) {
      target.facets = target.facets.map((facetSource: Facet) => {
        const { topValues, ...facetTarget } = facetSource
        facetTarget.topValueCount =
          topValues?.length > 0 ? topValues.length : this.DEFAULT_TOP_VALUES
        return facetTarget
      })
    }
  }
}
